import React, { useEffect, useState } from 'react'
import { Field } from 'formik'
import { TextField, Select, MenuItem, FormControl, InputLabel, ListSubheader, FormHelperText } from '@material-ui/core'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { ApiURL } from '../constants/ApiUrl'

function FormPage4({ errors, touched, values, setFieldValue }) {
    const NStates = useSelector(state => state.FormDataReducer.nmo_states)
    const [SName, setSName] = useState('');
    const [PName, setPName] = useState('');
    const [PList, setPList] = useState([]);
    const [Email, setEmail] = useState("")
    const [nmoStateList, setNmoStateList] = useState([]);   // 25 oct  jyoti
    const [nmoPrant, setNmoPrant] = useState([])
    const [disable, SetDisable] = useState(false)    // 25 oct jyoti added for NMO state list and prant list from database

    useEffect(() => {
        a();
        if (values.state != "") {
            stateChanged(values.state)
        }
    }, [])
    var s = []
    //  25 oct jyoti
    //  make "a()" function for getting state list which is store in DB
    const a = async () => {

        const result = await axios.get(`${ApiURL}/api/get_states`);

        console.log(result.data, "api result..")
        result.data.forEach(element => {
            console.log(element.state_name, "ellee")
            s.push(element.state_name)
        });
        setNmoStateList(s)
    }
    useEffect(() => {
        // console.log(NStates);
        setSName(values.nmo_state);
        // if(values.state !== '')
        // {            
        //     NStates.forEach(element => {
        //         element.states.forEach(element1 => {
        //             if(element1.state === values.nmo_state)
        //                 setPList(element1.prant)
        //         });
        //     });
        // }
        setPName(values.prant);
        // eslint-disable-next-line 
    }, [values.nmo_state, values.prant])
    // var u=[]
    const stateChanged = async (e) => {
        // console.log(e.target.value);
        setFieldValue("nmo_state", e);
        const result = await axios.post(`${ApiURL}/api/get_prant`, {            // addinng API for getting prant
            "state": e
        });

        // console.log(result.data.prant_name,"prant ll...")
        setNmoPrant(result.data.prant_name)
        prantChanged(values.prant,e)

    }

    const prantChanged = async (e, state) => {
        console.log(e, 'statttttsssss')
        const result1 = await axios.post(`${ApiURL}/api/secretory_mail`, {            // addinng API for getting prant
            "prant": e,
            "state": state,
        });

        console.log(result1.data.email, 'security mail')
        if (result1.data.email != "") {
            setEmail(result1.data.email)
            EmailChange(result1.data.email)
            SetDisable(true)
        }
        else {
            SetDisable(false)

        }

        setFieldValue("prant", e);
    }

    const EmailChange = (e) => {
        setEmail(e)
        setFieldValue("state_sec_email", e)

    }
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="norFlexCon">
                <div className="ctrl">

                    <FormControl variant="outlined" fullWidth error={touched.nmo_state && errors.nmo_state}>
                        <InputLabel id="stateLabel">NMO State *</InputLabel>
                        <Field name="nmo_state" label="NMO State *" labelId="stateLabel" as={Select} value={SName} variant="outlined" onChange={(e)=>stateChanged(e.target.value)} fullWidth error={touched.nmo_state && errors.nmo_state} helperText={touched.nmo_state && errors.nmo_state} >
                            <MenuItem value=''>Select State</MenuItem>
                            {
                                nmoStateList.map((item, index) => {
                                    // <option key={index} value={item}>{item}</option>
                                    return <MenuItem key={index} value={item}>{item}</MenuItem>

                                })
                            }
                            {/* {      // 25 oct jyoti 
                                       added prant list and NMO state list from database
                            NStates.map((item) => {
                                return <ListSubheader>{item.zone}</ListSubheader> && 
                                item.states.map((item1,index)=>{
                                    console.log(item1);
                                    return <MenuItem key={index} value={item1.state}>{item1.state}</MenuItem>
                                })
                            })
                        } */}
                        </Field>
                        <FormHelperText error>{touched.nmo_state && errors.nmo_state}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">

                    <FormControl variant="outlined" fullWidth error={touched.prant && errors.prant}>
                        <InputLabel id="stateLabel1">Prant *</InputLabel>
                        <Field name="state" label="Prant *" labelId="stateLabel1" as={Select} value={PName} variant="outlined" onChange={(e) => prantChanged(e.target.value, values.nmo_state)} fullWidth error={touched.prant && errors.prant} helperText={touched.prant && errors.prant} >
                            <MenuItem value=''>Select Prant</MenuItem>
                            {nmoPrant.map((item, index) => (
                                <MenuItem key={index} value={item}>{item}</MenuItem>
                            ))}
                        </Field>
                        <FormHelperText error>{touched.prant && errors.prant}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">

                    <Field name="nmo_unit" label="Name of Primary NMO Unit" as={TextField} variant="outlined" fullWidth error={touched.nmo_unit && errors.nmo_unit} helperText={touched.nmo_unit && errors.nmo_unit} />
                </div>
                <div className="ctrl">

                    <Field name="ref_person" label="Name of Referring Person *" as={TextField} variant="outlined" fullWidth error={touched.ref_person && errors.ref_person} helperText={touched.ref_person && errors.ref_person} />
                </div>
                <div className="ctrl">

                    <Field name="ref_membership_no" label="NMO Membership Number of Referring Person *" as={TextField} variant="outlined" fullWidth error={touched.ref_membership_no && errors.ref_membership_no} helperText={touched.ref_membership_no && errors.ref_membership_no} />
                </div>
                <div className="ctrl">
                    <Field name="ref_person_phone" label="Contact Number of Referring Person *" as={TextField} variant="outlined" fullWidth error={touched.ref_person_phone && errors.ref_person_phone} helperText={touched.ref_person_phone && errors.ref_person_phone} />

                </div>
                <div className="ctrl">

                    <Field name="state_sec_email" disabled={disable} onChange={(e) => EmailChange(e.target.value)} label="NMO State Secretary Email *" value={Email} as={TextField} variant="outlined" fullWidth error={touched.state_sec_email && errors.state_sec_email} helperText={touched.state_sec_email && errors.state_sec_email} />
                </div>
            </div>

        </div>
    )
}

export default FormPage4
